import React from 'react';
import classnames from 'classnames';
import { CusProductListWishlistButtonProps } from '../../../cus-product-list.data';

export default function WishlistButton({
    isInWishlist,
    onClick,
    addToWishlistAriaLabel,
    removeFromWishlistAriaLabel,
    isWishlistReady
}: CusProductListWishlistButtonProps) {
    return (
        <button
            className={classnames('bs-product-list-container__item__wishlist', {
                'bs-product-list-container__item__wishlist--active': isInWishlist
            })}
            aria-label={isInWishlist ? removeFromWishlistAriaLabel : addToWishlistAriaLabel}
            onClick={onClick}
            type='button'
            data-testid='plp-wishlist-button'
            data-wishlist-state={isInWishlist ? 'active' : 'inactive'}
            disabled={!isWishlistReady}
        />
    );
}
